import React, { createContext, useContext, useState } from "react";
import { ClientConfig } from "../components/util/types/ClientConfig";
import currentClientConfig from "../config";

const ClientConfigContext = createContext<ClientConfig | null>(null);

export const ClientConfigProvider = ({ children }: { children: React.ReactNode }) => {
  const [config, setConfig] = useState<ClientConfig>(currentClientConfig);

  return <ClientConfigContext.Provider value={config}>{children}</ClientConfigContext.Provider>;
};

export const useClientConfig = (): ClientConfig => {
  const context = useContext(ClientConfigContext);
  if (!context) {
    throw new Error("useClientConfig must be used within a ClientConfigProvider");
  }
  return context;
};

// used for the class component
export { ClientConfigContext };
